import { Schema } from "effect";
import { GmailProviderData } from "./gmail";
import { OutlookProviderData } from "./outlook";

// Union of all email provider data types
export const EmailProviderData = Schema.Union(
  GmailProviderData,
  OutlookProviderData,
);
export type EmailProviderData = typeof EmailProviderData.Type;

export const MessageEmailAddressType = Schema.Literal(
  "from",
  "to",
  "cc",
  "bcc",
);
export type MessageEmailAddressType = typeof MessageEmailAddressType.Type;

export const EmailAddressEntry = Schema.Struct({
  addressType: MessageEmailAddressType,
  email: Schema.String.pipe(Schema.minLength(1)),
  name: Schema.NullOr(Schema.String),
});
export type EmailAddressEntry = typeof EmailAddressEntry.Type;

import type { MessageResponse } from "../message";

export type EmailMessage = Extract<
  MessageResponse,
  { channel: "gmail" | "outlook" }
>;

export const isEmailMessage = (
  message: MessageResponse,
): message is EmailMessage => {
  return message.channel === "gmail" || message.channel === "outlook";
};
